import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./component/Header";
import Footer from "./component/Footer";
import Home from "./component/Home";
import About from "./component/About";
import Choose from "./component/Choose";
import Services from "./component/Services";
import Contact from "./component/Contact";
import Write from "./component/Write";
import Feedbacklist from "./component/Feedbacklist";
import UrologyCareSection from "./component/CareSection";
// import NotFound from './component/NotFound'; 
import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="flex flex-col min-h-screen">
          <Header />

          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                  <About />
                  <UrologyCareSection />
                  <Choose />
                  <Services />
                  <Feedbacklist />
                  <Contact />
                </>
              }
            />
            <Route path="/feedback" element={<Write />} />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
          
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
